<template >
	<div
		v-bind="getAttrs($attrs)"
		class="WurldInput"
	>
		<label
			v-bind="getAttrs($attrs, 'label')"
			v-if="label && !labelAfter"
			v-html="label"
			:for="guid"
		></label>
		<input
			@input="$emit('input', $event.target.value)"
			v-bind="getAttrs($attrs, 'input')"
			:id="label || uid ? guid : null"
			:name="name"
			:type="type"
			:value="value"
		>
		<label
			v-bind="getAttrs($attrs, 'label')"
			v-html="label"
			v-if="label && labelAfter"
			:for="guid"
		></label>
	</div>
</template>

<script>
export default {
	name: 'WurldInput',
	inheritAttrs: false,
	props: {
		label: {
			default: null,
			type: String
		},
		labelAfter: {
			default: false,
			type: Boolean
		},
		name: {
			default: null,
			type: String
		},
		uid: {
			default: null,
			type: String
		},
		type: {
			default: 'text',
			type: String
		},
		value: {
			default: null,
			type: String
		}
	},
	data () {
		return {
			guid: ''
		};
	},
	mounted () {
		this.guid = this.uid ? this.uid : this.generateUID('WurldInput');
	}
};
</script>
